<template>
  <v-container id="enewsletter">
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col>
        <span class="text-tcdc-green header bold">E-newsletter</span>
      </v-col>
    </v-row>
    <v-layout>
      <v-flex>
        <div class="mb-3 text-tcdc-grey1">{{ $t('enewsletter.email') }}</div>
        <v-text-field
            outlined
            dense
            color="#34A93E"
            type="email"
            v-model="myEmail"
            :placeholder="$t('enewsletter.youremail')"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout class="mb-5">
      <v-flex>
        <div class="mb-3 text-tcdc-grey1">{{ $t('enewsletter.interest') }}</div>
        <div class="mb-3" style="position: relative;"
             :class="{ 'd-flex flex-wrap': $vuetify.breakpoint.smAndUp }"
             :style="{ 'height': $vuetify.breakpoint.xs ? '300px':'auto', 'overflow-y': $vuetify.breakpoint.xs ? 'scroll':'none' }">
          <v-chip
              v-for="(chip, i) in allCategories"
              :key="i"
              color="#34A93E"
              class="mb-3 mr-2"
              :outlined="!myCate.includes(chip[`name_${lang}`])"
              :text-color="myCate.includes(chip[`name_${lang}`]) ? '#fff':'#000'"
              :class="{ 'selectedCate': myCate.includes(chip[`name_${lang}`]) }"
              @click="addInterested(chip[`name_${lang}`])"
          >
            {{ chip[`name_${lang}`] }}
          </v-chip>
        </div>
        <div class="d-flex align-center">
          <v-checkbox
              dense
              hide-details
              class="mt-0 pt-0"
              color="#2e8037"
              :input-value="isAccept"
              @change="isAccept = $event"
          ></v-checkbox>
          <span style="font-family: 'Sarabun', sans-serif; font-size: 16px">
                  {{ $t('enewsletter.agreement') }}

                  <a
                      :href="$i18n.locale === 'en' ? 'https://www.cea.or.th/en/privacy-policy' : 'https://www.cea.or.th/th/privacy-policy'"
                      target="_blank"
                      style="color: #2e8037 !important;"
                  >
                    {{ $i18n.locale === 'en' ? 'Privacy Policy' : 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล' }}
                  </a>
                </span>
        </div>
      </v-flex>
    </v-layout>
    <div class="d-flex justify-center">
      <v-btn :disabled="!isAccept" height="30" width="120" class="btn-enews-class" @click="getSubscribe">
        {{ $t('enewsletter.subscribe') }}
      </v-btn>
    </div>
    <AlertModal
        :show="dialog"
        :message="resMessage"
        :no-btn="true"
        :center-text="true"
    ></AlertModal>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import AlertModal from "../../components/modals/AlertModal";

export default {
  components: {
    AlertModal
  },
  async created() {
    this.items[0].text = this.branchName;
    await this.$store.dispatch('Contact/onGetCategoryEnewsletter');
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      allCategories: state => state.Contact.categories
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function () {
      this.items[0].text = this.branchChanged;
    }
  },
  methods: {
    addInterested(item) {
      if (this.myCate.includes(item)) {
        this.myCate = this.myCate.filter(x => x !== item);
      } else {
        this.myCate.push(item);
      }
    },
    getSubscribe() {
      if (this.myEmail) {
        // validate email pattern
        let regEx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        if (regEx.test(this.myEmail) && this.myCate && this.myCate.length > 0) {
          this.$store.dispatch('Contact/onSubscribeEnewsletter', {
            email: this.myEmail,
            interested: this.myCate
          }).then(() => {
            this.resMessage = this.$t('messageBox.enews-success');
            this.dialog = true;
            this.myEmail = "";
            this.myCate = [];
            this.closeDialog()
          }).catch(() => {
            this.resMessage = this.$t('messageBox.enews-failed');
            this.dialog = true;
            this.closeDialog()
          });
        } else {
          this.resMessage = this.$t('messageBox.enews-validate');
          this.dialog = true;
          this.closeDialog()
        }
      } else {
        this.resMessage = this.$t('messageBox.enews-validate');
        this.dialog = true;
        this.closeDialog()
      }
    },
    async closeDialog() {
      await new Promise((res, rej) => setTimeout(res, 5000))
      this.dialog = false
    }
  },
  data: () => ({
    myEmail: '',
    myCate: [],
    dialog: false,
    resMessage: '',
    isAccept: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        href: "/home"
      },
      {
        text: "TCDC E-Newsletter",
      }
    ]
  })
};
</script>

<style>
.selectedCate {
  background: #34A93E !important;
  color: #fff !important;
  border: solid 1px #34A93E;
}

.btn-enews-class {
  font-family: "Poppins", "Kanit", sans-serif;
  font-weight: bold;
  color: #fff !important;
  background-color: #2e8037 !important;
  border-radius: 30px;
}
</style>
